import Button from '../../../components/base/Button';

export default function CommunitySection() {
  const communityFeatures = [
    {
      icon: 'ri-global-line',
      title: 'Global Network',
      description: 'Connect with like-minded leaders across 50+ countries',
      stats: '10,000+ Members'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Exclusive Events',
      description: 'Monthly masterclasses, retreats, and networking gatherings',
      stats: '100+ Events Yearly'
    },
    {
      icon: 'ri-message-3-line',
      title: 'Mastermind Groups',
      description: 'Small group coaching and peer accountability circles',
      stats: '500+ Active Groups'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Resource Library',
      description: 'Exclusive content, tools, and templates for growth',
      stats: '1,000+ Resources'
    }
  ];

  const upcomingEvents = [
    {
      title: 'Wealth Consciousness Summit',
      date: 'June 20-22, 2025',
      location: 'Cape Town, South Africa',
      type: 'Retreat',
      image: 'https://public.readdy.ai/ai/img_res/4fcdba407e64deb9523b1e4c51c84da4.jpg'
    },
    {
      title: 'Legacy Building Masterclass',
      date: 'July 15, 2025',
      location: 'Virtual Event',
      type: 'Masterclass',
      image: 'https://readdy.ai/api/search-image?query=Modern%20virtual%20conference%20setup%20with%20multiple%20screens%20showing%20African%20American%20and%20Latino%20global%20participants%2C%20elegant%20home%20office%20setting%20with%20golden%20accents%2C%20high-tech%20professional%20atmosphere%2C%20luxury%20online%20event%20aesthetic%2C%20no%20white%20people&width=300&height=200&seq=virtual-masterclass-v2&orientation=landscape'
    },
    {
      title: 'CROWN Leadership Intensive',
      date: 'August 10-12, 2025',
      location: 'Johannesburg, South Africa',
      type: 'Intensive',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20conference%20room%20in%20Johannesburg%20South%20Africa%20with%20floor-to-ceiling%20windows%20overlooking%20city%20skyline%2C%20luxury%20contemporary%20interior%2C%20African%20American%20and%20Latino%20leaders%20in%20leadership%20retreat%20setting%2C%20inspiring%20urban%20atmosphere%2C%20no%20white%20people%2C%20sophisticated%20African%20business%20setting&width=300&height=200&seq=joburg-intensive-2025&orientation=landscape'
    }
  ];

  return (
    <section id="community" className="py-20 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-white" style={{ fontFamily: '"Playfair Display", serif' }}>
            The <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">CROWN</span> Community
          </h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Join a global family of conscious leaders, entrepreneurs, and visionaries committed to creating abundance and positive impact in the world.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {communityFeatures.map((feature, index) => (
            <div key={index} className="text-center bg-slate-800/50 backdrop-blur-sm rounded-2xl p-6 border border-amber-400/20 hover:border-amber-400/40 transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-r from-amber-500 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold mb-2 text-white">{feature.title}</h3>
              <p className="text-gray-300 mb-3 text-sm">{feature.description}</p>
              <div className="text-amber-400 font-semibold">{feature.stats}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold mb-6 text-white" style={{ fontFamily: '"Playfair Display", serif' }}>
              More Than a Community
            </h3>
            <p className="text-gray-200 mb-6 leading-relaxed">
              The CROWN community is a sacred space where transformation happens through connection, collaboration, and conscious growth. Our members support each other's journey to abundance while creating positive ripple effects in their communities.
            </p>
            <div className="space-y-4 mb-8">
              <div className="flex items-center">
                <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-200">24/7 private community platform access</span>
              </div>
              <div className="flex items-center">
                <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-200">Monthly virtual and in-person gatherings</span>
              </div>
              <div className="flex items-center">
                <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-200">Peer mentorship and accountability partnerships</span>
              </div>
              <div className="flex items-center">
                <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-200">Exclusive investment and business opportunities</span>
              </div>
            </div>
            <Button variant="primary" size="lg">
              Join Our Community
            </Button>
          </div>
          
          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Diverse%20group%20of%20successful%20African%20American%20and%20Latino%20entrepreneurs%20and%20leaders%20networking%20at%20an%20elegant%20evening%20event%20with%20golden%20lighting%2C%20luxury%20venue%20setting%2C%20people%20engaged%20in%20meaningful%20conversations%2C%20community%20and%20connection%20atmosphere%2C%20no%20white%20people%2C%20only%20Black%20and%20Latino%20professionals&width=600&height=400&seq=community-networking-v2&orientation=landscape"
              alt="CROWN Community Gathering"
              className="rounded-2xl shadow-2xl object-cover w-full h-80"
            />
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold text-center mb-12 text-white" style={{ fontFamily: '"Playfair Display", serif' }}>
            Upcoming Events
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {upcomingEvents.map((event, index) => (
              <div key={index} className="bg-slate-800 rounded-2xl overflow-hidden hover:bg-slate-700 transition-all duration-300 border border-slate-700 hover:border-amber-400/30 transform hover:-translate-y-1 shadow-lg">
                <img 
                  src={event.image}
                  alt={event.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="bg-amber-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                      {event.type}
                    </span>
                    <span className="text-gray-300 text-sm">{event.date}</span>
                  </div>
                  <h4 className="text-xl font-bold mb-2 text-white">{event.title}</h4>
                  <p className="text-gray-300 mb-4">
                    <i className="ri-map-pin-line mr-2"></i>
                    {event.location}
                  </p>
                  <button className="text-amber-400 hover:text-amber-300 font-medium transition-colors duration-200 cursor-pointer">
                    Learn More <i className="ri-arrow-right-line ml-1"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
